import * as React from "react";
import { THEMES } from "./Themes";
const ActivityLegendBase = ({ data, title, theme }) => {
    const selectedTheme = THEMES[theme || "dark"];
    const textStyle = Object.assign(Object.assign({}, styles.text), { color: selectedTheme.LegendColorPercentage });
    const labelStyle = { color: selectedTheme.LegendColor };
    return (React.createElement("div", { style: styles.container },
        React.createElement("h3", { style: textStyle }, title),
        data.map((ring, idx) => {
            const bulletColor = ring.color || selectedTheme.RingColors[idx];
            const bulletStyle = Object.assign(Object.assign({}, styles.bullets), { backgroundColor: bulletColor });
            return (React.createElement("div", { style: styles.row, key: `l_${idx}` },
                React.createElement("div", { style: bulletStyle }),
                ring.label && (React.createElement("p", { style: textStyle },
                    `${Math.round(ring.value * 100)}% `,
                    React.createElement("span", { style: labelStyle }, ring.label)))));
        })));
};
const styles = {
    container: {
        marginLeft: 10
    },
    row: {
        display: "flex",
        alignItems: "center"
    },
    bullets: {
        width: 16,
        height: 16,
        borderRadius: 8
    },
    text: {
        padding: 7,
        margin: 0
    }
};
const ActivityLegend = React.memo(ActivityLegendBase);
export default ActivityLegend;
